module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--31.7c2ee2ff.png";